import React, { useState } from "react";
import ProfileFeedbackAlert from "../../features/profile/components/ProfileFeedbackAlert";
import ProfileAboutSection from "../../features/profile/components/ProfileAboutSection";
import ProfileGoalsSection from "../../features/profile/components/ProfileGoalsSection";
import { useProfileForm } from "../../features/profile/hooks/useProfileForm";
import HistoricalDataImportModal from "../../features/profile/components/HistoricalDataImportModal";

const Profile = () => {
  const {
    loading,
    saving,
    message,
    isEditing,
    setIsEditing,
    profile,
    setProfile,
    userName,
    imc,
    healthQuery,
    setHealthQuery,
    isHealthOpen,
    setIsHealthOpen,
    healthInputRef,
    healthDropdownWrapperRef,
    healthOptions,
    canAddMoreHealthIssues,
    handleSave,
    cancelEdit,
    addHealthIssue,
    removeHealthIssue,
    handleHealthKeyDown,
  } = useProfileForm();

  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  if (loading) {
    return (
      <div className="space-y-4 py-2 animate-pulse">
        <div className="h-32 rounded-3xl skeleton-loading w-full" />
        <div className="h-44 rounded-3xl skeleton-loading w-full" />
        <div className="h-44 rounded-3xl skeleton-loading w-full" />
      </div>
    );
  }

  const initial = profile?.displayName
    ? profile.displayName.charAt(0).toUpperCase()
    : userName
      ? userName.charAt(0).toUpperCase()
      : "M";

  return (
    <div className="space-y-4">
      {/* HEADER DE PERFIL LITI */}
      <div className="liti-card p-5 shadow-sm border border-[#ECE7FA] flex items-center justify-between gap-4">
        <div className="flex items-center gap-3.5 min-w-0">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#6C54D8] text-white font-black text-xl shadow-xs">
            {initial}
          </div>

          <div className="min-w-0">
            <h1 className="text-lg font-bold text-[#24152F] truncate font-serif">
              {profile?.displayName || userName || "Meu Perfil"}
            </h1>
            <p className="text-xs font-semibold text-[#6C54D8] truncate">
              {profile?.gender || "Informações Biométricas"}
            </p>
          </div>
        </div>

        {!isEditing && (
          <button
            type="button"
            onClick={() => setIsEditing(true)}
            className="btn-secondary text-xs font-bold h-10 px-4 shrink-0 flex items-center gap-1.5 cursor-pointer"
          >
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
            </svg>
            Editar
          </button>
        )}
      </div>

      <ProfileFeedbackAlert message={message} />

      {/* BANNER DE IMPORTAÇÃO DE PLANILHA */}
      <div className="liti-card p-5 shadow-sm border border-[#ECE7FA] flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="flex items-center gap-3.5">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#ECE7FA] text-xl">
            📊
          </div>
          <div>
            <h3 className="text-sm font-bold text-[#24152F]">
              Importar Histórico (Planilha CSV)
            </h3>
            <p className="text-xs font-medium text-[#6D6680]">
              Suba dados anteriores de peso, medidas corporais, água e doses.
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={() => setIsImportModalOpen(true)}
          className="btn-primary text-xs font-bold h-10 px-5 shrink-0 cursor-pointer"
        >
          Importar CSV
        </button>
      </div>

      <ProfileAboutSection
        isEditing={isEditing}
        profile={profile}
        setProfile={setProfile}
        userName={userName}
        imc={imc}
      />

      <ProfileGoalsSection
        isEditing={isEditing}
        profile={profile}
        setProfile={setProfile}
        healthQuery={healthQuery}
        setHealthQuery={setHealthQuery}
        isHealthOpen={isHealthOpen}
        setIsHealthOpen={setIsHealthOpen}
        healthInputRef={healthInputRef}
        healthDropdownWrapperRef={healthDropdownWrapperRef}
        healthOptions={healthOptions}
        canAddMoreHealthIssues={canAddMoreHealthIssues}
        addHealthIssue={addHealthIssue}
        removeHealthIssue={removeHealthIssue}
        handleHealthKeyDown={handleHealthKeyDown}
      />

      {isEditing && (
        <div className="space-y-2 pt-2">
          <button
            type="button"
            disabled={saving}
            onClick={handleSave}
            className="btn-primary w-full h-12 text-xs font-bold uppercase tracking-wider shadow-md flex items-center justify-center gap-2 disabled:opacity-60 cursor-pointer"
          >
            {saving ? (
              <>
                <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" />
                Salvando...
              </>
            ) : (
              "Salvar Alterações"
            )}
          </button>

          <button
            type="button"
            disabled={saving}
            onClick={cancelEdit}
            className="btn-secondary w-full h-11 text-xs font-bold uppercase tracking-wider disabled:opacity-60 cursor-pointer"
          >
            Cancelar
          </button>
        </div>
      )}

      {/* MODAL DE IMPORTAÇÃO CSV */}
      <HistoricalDataImportModal
        isOpen={isImportModalOpen}
        onClose={() => setIsImportModalOpen(false)}
        onSuccess={() => setIsImportModalOpen(false)}
      />
    </div>
  );
};

export default Profile;